import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=a222a716&"
import script from "./AuthCallback.vue?vue&type=script&lang=js&"
export * from "./AuthCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports